"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoricalEvent2ToJSON = exports.HistoricalEvent2FromJSONTyped = exports.HistoricalEvent2FromJSON = exports.instanceOfHistoricalEvent2 = void 0;
var runtime_1 = require("../runtime");
var EventType_1 = require("./EventType");
/**
 * Check if a given object implements the HistoricalEvent2 interface.
 */
function instanceOfHistoricalEvent2(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfHistoricalEvent2 = instanceOfHistoricalEvent2;
function HistoricalEvent2FromJSON(json) {
    return HistoricalEvent2FromJSONTyped(json, false);
}
exports.HistoricalEvent2FromJSON = HistoricalEvent2FromJSON;
function HistoricalEvent2FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': !(0, runtime_1.exists)(json, 'type') ? undefined : (0, EventType_1.EventTypeFromJSON)(json['type']),
        'hourPartition': !(0, runtime_1.exists)(json, 'hour_partition') ? undefined : (new Date(json['hour_partition'])),
        'count': !(0, runtime_1.exists)(json, 'count') ? undefined : json['count'],
    };
}
exports.HistoricalEvent2FromJSONTyped = HistoricalEvent2FromJSONTyped;
function HistoricalEvent2ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'type': (0, EventType_1.EventTypeToJSON)(value.type),
    };
}
exports.HistoricalEvent2ToJSON = HistoricalEvent2ToJSON;
